import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  container: {
    padding: theme.spacing.md,
    backgroundColor: theme.white,
  },
  header: {
    marginBottom: theme.spacing.lg,
  },
}));
